import { Button, Container, Icons, Tooltip } from "@osttra/ds-react";
import "./ApplicationCard.css";

interface UserApplication {
  appName: string;
  homepageUrl: string;
  userMail: string;
}

const ApplicationCard = ({ appName, homepageUrl, userMail }: UserApplication) => {
  const handleApplicationClick = (appHomePageUrl: string) => {
    if (appHomePageUrl && appHomePageUrl.trim() !== "") {
      window.open(appHomePageUrl, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div className="card t-flex t-nowrap">
      <Container className="t-wrap" compact header={appName}>
        <div>
          <Tooltip message={userMail} placement="top">
            <span className="user-mail">
              <Icons.User color="subtle" />
              {userMail}
            </span>
          </Tooltip>
        </div>

        <div className="launch-btn">
          <Button
            type="primary"
            variant="outlined"
            icon="external-link"
            onClick={() => handleApplicationClick(homepageUrl)}
          >
            Launch
          </Button>
        </div>
      </Container>
    </div>
  );
};

export default ApplicationCard;
